// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Income/IncomeDetailModal.css */

.income-detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.income-detail-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

/* Header */
.income-detail-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.income-detail-modal .header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.income-detail-modal .header-title .type-icon {
  font-size: 28px;
}

.income-detail-modal .header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.income-detail-modal .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.income-detail-modal .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Legend */
.income-detail-modal .modal-legend {
  display: flex;
  gap: 20px;
  padding: 12px 24px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  flex-wrap: wrap;
}

.income-detail-modal .legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748B;
}

.income-detail-modal .legend-item .badge {
  font-size: 14px;
}

/* Body */
.income-detail-modal .modal-body {
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1 1;
}

/* Sections */
.income-detail-modal .modal-section {
  margin-bottom: 12px;
}

.income-detail-modal .modal-section:last-child {
  margin-bottom: 0;
}

.income-detail-modal .section-title {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 8px 0;
  padding-bottom: 4px;
  border-bottom: 1px solid #E2E8F0;
}

.income-detail-modal .total-section {
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  padding: 8px 12px;
  border-radius: 6px;
  margin: 8px 0;
}

.income-detail-modal .fields-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Form field */
.income-detail-modal .form-field {
  display: flex;
  flex-direction: column;
}

.income-detail-modal .form-field .field-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.income-detail-modal .form-field label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
}

.income-detail-modal .form-field .field-label {
  flex: 1 1;
}

.income-detail-modal .form-field .field-value {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.income-detail-modal .form-field .formula {
  font-size: 10px;
  color: #94A3B8;
  font-style: italic;
}

/* Total field styling */
.income-detail-modal .form-field.is-total {
  padding: 0;
  background: none;
  border: none;
}

.income-detail-modal .form-field.is-total label {
  font-weight: 700;
  color: #1E293B;
}

.income-detail-modal .form-field.is-total input {
  font-weight: 700;
  font-size: 16px;
  background: transparent !important;
}

/* Field type badge */
.income-detail-modal .field-type-badge {
  font-size: 12px;
  flex-shrink: 0;
}

/* Help tooltip */
.income-detail-modal .help-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.income-detail-modal .help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #CBD5E1;
  color: white;
  font-size: 10px;
  font-weight: 700;
  cursor: help;
  transition: background 0.2s;
}

.income-detail-modal .help-icon:hover {
  background: #3B82F6;
}

.income-detail-modal .help-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1E293B;
  color: white;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
  width: 280px;
  max-width: 90vw;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.income-detail-modal .help-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1E293B;
}

/* Input styles */
.income-detail-modal .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 6px;
}

.income-detail-modal input[type="number"],
.income-detail-modal input[type="text"],
.income-detail-modal select {
  padding: 5px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
}

.income-detail-modal input[type="number"]:focus,
.income-detail-modal input[type="text"]:focus,
.income-detail-modal select:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.income-detail-modal input.auto-calculated {
  background: #F1F5F9;
  color: #64748B;
  cursor: not-allowed;
  font-weight: 600;
}

.income-detail-modal .suffix {
  color: #64748B;
  font-size: 13px;
  white-space: nowrap;
}

/* Checkbox */
.income-detail-modal .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.income-detail-modal .checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.income-detail-modal .checkbox-text {
  font-size: 14px;
  color: #334155;
}

/* Info text */
.income-detail-modal .info-text {
  font-size: 13px;
  color: #64748B;
  font-style: italic;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 6px;
  border-left: 3px solid #3B82F6;
}

/* Field type styling */
.income-detail-modal .field-type-auto {
  background: #EFF6FF;
  padding: 6px 10px;
  border-radius: 4px;
  border-left: 3px solid #3B82F6;
}

.income-detail-modal .field-type-estimated {
  background: #FFFBEB;
  padding: 6px 10px;
  border-radius: 4px;
  border-left: 3px solid #F59E0B;
}

.income-detail-modal .field-type-manual {
  background: #F8FAFC;
  padding: 6px 10px;
  border-radius: 4px;
  border-left: 3px solid #94A3B8;
}

/* Footer */
.income-detail-modal .modal-footer {
  padding: 12px 24px;
  background: #F8FAFC;
  border-top: 1px solid #E2E8F0;
}

.income-detail-modal .summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 13px;
}

.income-detail-modal .summary-row span {
  color: #64748B;
}

.income-detail-modal .summary-row strong {
  color: #1E293B;
  font-size: 15px;
}

.income-detail-modal .actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #E2E8F0;
}

.income-detail-modal .cancel-btn {
  padding: 10px 20px;
  border: 1px solid #E2E8F0;
  background: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.income-detail-modal .cancel-btn:hover {
  background: #F8FAFC;
  border-color: #CBD5E1;
}

.income-detail-modal .save-btn {
  padding: 10px 24px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
}

.income-detail-modal .save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* Responsive */
@media (max-width: 600px) {
  .income-detail-modal {
    max-height: 100vh;
    border-radius: 0;
  }

  .income-detail-modal .modal-legend {
    flex-direction: column;
    gap: 8px;
  }

  .income-detail-modal input[type="number"],
  .income-detail-modal input[type="text"],
  .income-detail-modal select {
    max-width: 100%;
  }

  .income-detail-modal .help-tooltip {
    width: 220px;
    left: 0;
    transform: translateX(0);
  }

  .income-detail-modal .help-tooltip::after {
    left: 20px;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Income/IncomeDetailModal.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,OAAO;IACP,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":["/* src/components/Income/IncomeDetailModal.css */\n\n.income-detail-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.income-detail-modal {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n/* Header */\n.income-detail-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.income-detail-modal .header-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.income-detail-modal .header-title .type-icon {\n  font-size: 28px;\n}\n\n.income-detail-modal .header-title h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.income-detail-modal .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.income-detail-modal .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Legend */\n.income-detail-modal .modal-legend {\n  display: flex;\n  gap: 20px;\n  padding: 12px 24px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  flex-wrap: wrap;\n}\n\n.income-detail-modal .legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.income-detail-modal .legend-item .badge {\n  font-size: 14px;\n}\n\n/* Body */\n.income-detail-modal .modal-body {\n  padding: 16px 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Sections */\n.income-detail-modal .modal-section {\n  margin-bottom: 12px;\n}\n\n.income-detail-modal .modal-section:last-child {\n  margin-bottom: 0;\n}\n\n.income-detail-modal .section-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 8px 0;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.income-detail-modal .total-section {\n  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  margin: 8px 0;\n}\n\n.income-detail-modal .fields-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Form field */\n.income-detail-modal .form-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.income-detail-modal .form-field .field-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.income-detail-modal .form-field label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.income-detail-modal .form-field .field-label {\n  flex: 1;\n}\n\n.income-detail-modal .form-field .field-value {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.income-detail-modal .form-field .formula {\n  font-size: 10px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* Total field styling */\n.income-detail-modal .form-field.is-total {\n  padding: 0;\n  background: none;\n  border: none;\n}\n\n.income-detail-modal .form-field.is-total label {\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.income-detail-modal .form-field.is-total input {\n  font-weight: 700;\n  font-size: 16px;\n  background: transparent !important;\n}\n\n/* Field type badge */\n.income-detail-modal .field-type-badge {\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n/* Help tooltip */\n.income-detail-modal .help-tooltip-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.income-detail-modal .help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #CBD5E1;\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: help;\n  transition: background 0.2s;\n}\n\n.income-detail-modal .help-icon:hover {\n  background: #3B82F6;\n}\n\n.income-detail-modal .help-tooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1E293B;\n  color: white;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.5;\n  width: 280px;\n  max-width: 90vw;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.income-detail-modal .help-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #1E293B;\n}\n\n/* Input styles */\n.income-detail-modal .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.income-detail-modal input[type=\"number\"],\n.income-detail-modal input[type=\"text\"],\n.income-detail-modal select {\n  padding: 5px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  width: 100%;\n}\n\n.income-detail-modal input[type=\"number\"]:focus,\n.income-detail-modal input[type=\"text\"]:focus,\n.income-detail-modal select:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.income-detail-modal input.auto-calculated {\n  background: #F1F5F9;\n  color: #64748B;\n  cursor: not-allowed;\n  font-weight: 600;\n}\n\n.income-detail-modal .suffix {\n  color: #64748B;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n/* Checkbox */\n.income-detail-modal .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.income-detail-modal .checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.income-detail-modal .checkbox-text {\n  font-size: 14px;\n  color: #334155;\n}\n\n/* Info text */\n.income-detail-modal .info-text {\n  font-size: 13px;\n  color: #64748B;\n  font-style: italic;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  border-left: 3px solid #3B82F6;\n}\n\n/* Field type styling */\n.income-detail-modal .field-type-auto {\n  background: #EFF6FF;\n  padding: 6px 10px;\n  border-radius: 4px;\n  border-left: 3px solid #3B82F6;\n}\n\n.income-detail-modal .field-type-estimated {\n  background: #FFFBEB;\n  padding: 6px 10px;\n  border-radius: 4px;\n  border-left: 3px solid #F59E0B;\n}\n\n.income-detail-modal .field-type-manual {\n  background: #F8FAFC;\n  padding: 6px 10px;\n  border-radius: 4px;\n  border-left: 3px solid #94A3B8;\n}\n\n/* Footer */\n.income-detail-modal .modal-footer {\n  padding: 12px 24px;\n  background: #F8FAFC;\n  border-top: 1px solid #E2E8F0;\n}\n\n.income-detail-modal .summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.income-detail-modal .summary-row span {\n  color: #64748B;\n}\n\n.income-detail-modal .summary-row strong {\n  color: #1E293B;\n  font-size: 15px;\n}\n\n.income-detail-modal .actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.income-detail-modal .cancel-btn {\n  padding: 10px 20px;\n  border: 1px solid #E2E8F0;\n  background: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.income-detail-modal .cancel-btn:hover {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n}\n\n.income-detail-modal .save-btn {\n  padding: 10px 24px;\n  border: none;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.income-detail-modal .save-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .income-detail-modal {\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .income-detail-modal .modal-legend {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .income-detail-modal input[type=\"number\"],\n  .income-detail-modal input[type=\"text\"],\n  .income-detail-modal select {\n    max-width: 100%;\n  }\n\n  .income-detail-modal .help-tooltip {\n    width: 220px;\n    left: 0;\n    transform: translateX(0);\n  }\n\n  .income-detail-modal .help-tooltip::after {\n    left: 20px;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
